var _defs, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _ellipse2, _path25, _ellipse3, _path26, _path27, _rect2, _path28, _path29, _path30, _ellipse4, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M829.67,444c-2.23,12.53-6.79,25.88-12.32,38.76C787.69,551.81,731.42,606,661.6,633.93c-116.86,46.74-250.16,33-250.16,33C48.75,690.45,28.88,434.5,28.88,434.5c-6.76-61.69.48-115,15.42-160.49q2.34-7.12,4.93-14t5.32-13.31a357.12,357.12,0,0,1,21.31-42.31q4.5-7.65,9.23-14.84c4.3-6.58,8.73-12.89,13.22-18.92,54.14-72.63,119-106.14,119-106.14S323,8.34,461.38,14.55c67.67,3,143.16,21,217.92,67.77a487.79,487.79,0,0,1,45.43,32.21s11.54,10.1,27.29,28.75c22,26,52.15,68.62,70.69,123.65a319.65,319.65,0,0,1,14,59.51A306.65,306.65,0,0,1,829.67,444Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M829.67,444c-2.23,12.53-6.79,25.88-12.32,38.76C787.69,551.81,731.42,606,661.6,633.93c-116.86,46.74-250.16,33-250.16,33-56.22,3.64-104.2.57-145.15-7.22C43.06,617.25,28.88,434.5,28.88,434.5c-6.76-61.69.48-115,15.42-160.49q2.34-7.12,4.93-14t5.32-13.31a357.12,357.12,0,0,1,21.31-42.31q4.5-7.65,9.23-14.84,6.45-9.87,13.22-18.92c54.14-72.63,119-106.14,119-106.14l.61-.32c8.71-4.48,110-55,241.11-49.72h.23l2.08.09h.33q14.73.67,29.93,2.33l1.51.17A442.17,442.17,0,0,1,679.3,82.32a487.79,487.79,0,0,1,45.43,32.21s11.54,10.1,27.29,28.75c22,26,52.15,68.62,70.69,123.65a319.65,319.65,0,0,1,14,59.51A306.65,306.65,0,0,1,829.67,444Z",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M759.87,38.3a6.41,6.41,0,0,0-6.08,4.37H439.26a6.44,6.44,0,1,0,0,4.13H753.79a6.43,6.43,0,1,0,6.08-8.5Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.66,48c4.48,109,8.36,219.13,13.14,327.78l-.47,21.3s-20.16,0-30.77,1-27.05,1.06-38.72,1.06-18-4.24-18-4.24l.76-19.2C442,267.11,444.45,157,446.11,48",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 463.39,
    y1: 357.71,
    x2: 463.34,
    y2: 370.56,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.49,
    y1: 107.54,
    x2: 463.45,
    y2: 346.31,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 464.76,
    y1: 45.54,
    x2: 464.53,
    y2: 100.42,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 482.85,
    y1: 170.97,
    x2: 480.44,
    y2: 329.92,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 484.72,
    y1: 46.96,
    x2: 483,
    y2: 161.02,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.73,
    y1: 215.17,
    x2: 500.4,
    y2: 362.72,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.25,
    y1: 110.4,
    x2: 499.67,
    y2: 203.05,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 498.98,
    y1: 48.39,
    x2: 499.21,
    y2: 99,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.38,48c-4.3,115.45-9.8,232.07-13.93,346.92,0,0,13.72,2.07,22.57,2.07h45.05a129.45,129.45,0,0,0,20.87-2.15c-2-114.72-3.41-231.39-7-346.84",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 726.64,
    y1: 357.71,
    x2: 726.69,
    y2: 370.56,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 725.54,
    y1: 107.54,
    x2: 726.59,
    y2: 346.31,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 725.27,
    y1: 45.54,
    x2: 725.51,
    y2: 100.42,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 707.19,
    y1: 170.97,
    x2: 709.59,
    y2: 329.92,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 705.31,
    y1: 46.96,
    x2: 707.03,
    y2: 161.02,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690.3,
    y1: 215.17,
    x2: 689.63,
    y2: 362.72,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 690.78,
    y1: 110.4,
    x2: 690.36,
    y2: 203.05,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 691.05,
    y1: 48.39,
    x2: 690.83,
    y2: 99,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "515.65 78.94 547.31 78.94 547.31 115.87 517.77 115.87",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.83,
    y: 79.03,
    width: 33.09,
    height: 37.05,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "674.81 78.94 643.15 78.94 643.15 115.87 672.7 115.87",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.54,
    y: 79.03,
    width: 33.09,
    height: 37.05,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "520.88 246.76 586.76 246.76 586.76 136.03 517.98 136.03",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "671.48 135.1 604.13 135.1 604.13 246.76 666.4 246.76",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "523.05 273.02 586.76 273.02 586.76 384.33 527.88 384.33",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "667.13 272.09 604.13 272.09 604.13 385.36 661.57 385.36",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.59,
    y1: 392.44,
    x2: 662.45,
    y2: 392.44,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 515.39,
    y1: 66.12,
    x2: 674.73,
    y2: 66.12,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 595.45,
    y1: 66.89,
    x2: 595.45,
    y2: 390.91,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 517.41,
    y1: 127.48,
    x2: 672.41,
    y2: 127.48,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "106.68 75.94 157.77 75.94 174.83 150.04 152.9 150.04",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "146.91 150.04 79.75 150.04 96.82 75.94 101.54 75.94",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.48,
    y1: 234.71,
    x2: 131.48,
    y2: 533.3,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.48,
    y1: 221.01,
    x2: 131.48,
    y2: 227.86,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.11 449.56 123.11 150.03 131.48 150.03 131.48 215.45",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.11,
    y1: 533.3,
    x2: 123.11,
    y2: 457.69,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.88,
    y: 533.3,
    width: 75.73,
    height: 8.7,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.36,112.55H244.77l-27.32,47.31,27.32,47.3h54.62l27.31-47.3-27.31-47.31H280.48m15.85,89.36H247.82l-24.25-42,24.25-42.06h48.51l24.26,42Z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.14,65.13H326.52l-27.31,47.3,27.31,47.31h54.62l27.31-47.31Zm9.57,27.17,2.46,4.27m2.49,4.33,6.67,11.53-24.26,42H329.58l-24.26-42,24.26-42h48.51L388.7,88.83",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.48,235.2l11,19.12h54.62L408.45,207l-27.31-47.3H326.52L299.21,207l7.54,13m1.83,3.18,3.58,6.11m66,19.68H329.58l-24.26-42,24.26-42h48.51l24.26,42Z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.57 201.59 256.09 201.59 252.66 168.36 287 168.36 283.57 201.59",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "257.64 168.36 246.02 155.07 258.76 161.72 258.76 155.07 257.64 140.11 266.51 159.49 270.93 139.01 272.61 151.75 280.91 128.48 279.8 154.51 290.32 145.65 283.12 156.73 295.86 151.19 288.11 161.72 301.4 161.16 287 168.36",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.54 153.96 338.06 153.96 334.63 120.72 368.98 120.72 365.54 153.96",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,120.72a36.28,36.28,0,0,1-5.16-1.81c-.9-.6,0-2.08,0-2.08l-1.2-1.79,2.68-.9-1.19-3.59,1.49-.29-.9-4.47,2.39-.6.6-2.68,3.28-.3,1.19-2.39,2.39.3L341.4,98l3.27-.6,1.49.3,3-.88.6,1.48,4.18-1.48.3,2.39,2.39-1.2s-.3,1.49.6,1.49a10.3,10.3,0,0,0,3-1.2l.59,1.79,2.39-1.19.9,1.49h2.39v2.09l3-.59,2.69.59-.3,2.68.88,1.49,2.09.3-.59,2.39-.3,1.8,1.79.29-2.09,1.78,2.09.6-2.39,2.09,3,1.2-2.69.89-1.48,1.8V121l-3.11-.27",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "339.29 104.9 337.51 106.1 340.49 107.29 337.21 110.57 340.19 110.57 339.59 112.94 341.98 112.35 342.88 114.44 347.35 113.24 348.24 117.41 351.22 115.33 352.71 115.93 354.79 115.93 357.48 116.83 358.96 114.74 360.16 114.74 360.46 112.35",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.65 249.22 339.17 249.22 335.74 216 370.08 216 366.65 249.22",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,215.77s-1.2-1.2,2.09-7.76,9.83-6.85,11.62-9.56,3.87-11.32-3.88-11-8.94,6.85-10.75,7.17-3.28-3.87-4.47-.3,0,6.27,1.79,7.76.3,6.25.3,6.25a25.53,25.53,0,0,1-2.39-5.07c-1.2-3.27-6.55-3.58-6.55-6.54s3.27-9.24-1.2-12.83-10.43-.3-11,2.69,4.17,8.64,4.17,8.64-2.07,4.47.9,6.26l7.46,4.47s-4.47-1.49-5.67-.59.3,3.58-1.79,3.87-.9-2.68-2.08-6-5.07-4.47-5.07-7.44.3-7.17-3.28-6.27-10.42,6.86-6,10.76,8.05,5.67,7.75,6.85-5.37-.89-5.67,1.19,2.39,3.29,6.56,3.88,4.78,3.28,4.78,3.28",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.36,216.07s-3.28-2.39-3.28-3.89,6-2.39,6.85-2.39-1.48,2.39-1.48,2.39a4.1,4.1,0,0,0,4.47.9c2.39-1.2,3,2.69,3,2.69",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M460.63,594.31s37.08,26.73,78,13.8c0,0,12.07-5.18,31.47-.43,0,0,50.45,15.52,83.21-8.63l28.89-27.59s19-14.66-14.66-44.84c0,0-35.78-33.2-80.19-6,0,0-26.24,13.31-56,2.13,0,0-23.81-7.67-68.19,6.1,0,0-119-15.12-136.21,34.89C327,563.7,303.26,601.64,460.63,594.31Z",
    fill: "#fff",
    opacity: 0.18
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M691.8,561.56l4,17.54a10.36,10.36,0,0,1-9.7,12.67l-207,7.92a9.5,9.5,0,0,1-8.74-5h0a9.5,9.5,0,0,1,7.95-14l159.12-7.09-203.5,2.15L262.53,592.41a9.16,9.16,0,0,1-9.09-5h0a9.18,9.18,0,0,1,7.08-13.21l206.14-25.56-231.52-7.94a8,8,0,0,1-7.73-7.59h0a8,8,0,0,1,8.16-8.45l377.69,7.16L428.64,511.92a8.14,8.14,0,0,1-7.27-8.53h0a8.15,8.15,0,0,1,9.08-7.67l206.09,24s22.85,1.3,30.61,11.21l11.64,9.92s6.9,8.19,19,.86c0,0,40.1-10.78,50,12.07,0,0,6,24.07-49.75,5.7a1.67,1.67,0,0,0-.55-.09h-4A1.77,1.77,0,0,0,691.8,561.56Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "235.13 521.88 230.82 532.23 235.56 539.12 248.07 536.97 253.24 525.76 235.13 521.88",
    fill: "#f9b499"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1,530.5l-6.35,11.63A17.26,17.26,0,0,0,220.6,551c.17,4.09,1.86,8.74,8.5,9.21,0,0,8.57,2.14,16.85,4.53a52.73,52.73,0,0,0,13.67,2.06l14.85.25a5.51,5.51,0,0,0,5.11-3.19c2.42-5.32,5-15.44-9.52-17,0,0-22,2.59-20.7-6l1.73-5.61S234.27,537.4,229.1,530.5Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.74 516.27 60.95 517.13 61.38 537.83 76.9 536.97 74.74 516.27",
    fill: "#f9b499"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.65,561.54s-12.93-3-10.77-14.22c0,0,1.29-7.33,9.91-8.2,0,0,4.74,1.73,4.31-5.17l.07-16.7s2.52-3.56-7-3.13H31.63l.43,52.6s0,2.58,5.61,2.58H64.4S67.41,564.56,59.65,561.54Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241,247.88s4.75.86,9.92,8.19l13.37,45.7,2.58,66.4-4.25,38.62-36.71,21.74-58.63-4.74s9.48-39.67,11.64-44,16.81-89.68,16.81-89.68l14.23-42.25,5.18-3.45,8.19-.43Z",
    fill: "#f1f1f1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.71,480.49s58.21,2.58,79.33-1.3a93,93,0,0,0,3.88-18.11s2.16,2.16,2.16,17.68c0,0,16.38,5.18,47,1.73l6.46-23.29L261,428.32l7.33-20.27-12.07-13.79s-41,3.26-67.48-1.82l-18.32-5.95Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.71,480.49s58.21,2.58,79.33-1.3a93,93,0,0,0,3.88-18.11s2.16,2.16,2.16,17.68c0,0,16.38,5.18,47,1.73l6.46-23.29L261,428.32l7.33-20.27-12.07-13.79s-41,3.26-67.48-1.82l-18.32-5.95Z",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.94,518.43s9.49,13.8,33.2,11.21l60.36-65.11s19.4-20.26-1.72-37.08c0,0-22.42-13.79-50.45-19.4l-12.07-4.31a324.78,324.78,0,0,1-71.91-2.43L162.69,442a57.07,57.07,0,0,0-4.42,10.91c-3.1,10.72-9.7,34.19-13.25,51.29,0,0-28.88,0-72.43,7.76l-.43,27.16c12.16,1,25.12,1.59,38.8,1.73,15.77.16,30.61-.35,44.41-1.3,5.62.12,12.94-.17,15.81-5.23.76-1.34,1.48-2.7,2.28-4,5.37-8.91,22.66-38.65,40.55-80.86,0,0,24.57,11.64,61.65,8.63Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.22,391.88l-4.87,9.43s40,5.88,71.91,2.43v-9.48S208,396.53,189.22,391.88Z",
    fill: "#e5e5e5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 222.2,
    y: 395.12,
    width: 11.21,
    height: 9.49,
    fill: "#cbcbcb"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.53 388.22 236.43 397.7 241.6 389.08 239.88 265.34 241.6 263.62 241.71 254.99 236.13 254.99 232.98 260.6 236 265.77 229.53 388.22",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.27,229.35,220,244.64l15.06,10a1.86,1.86,0,0,0,1,.31h5.57a1.82,1.82,0,0,0,1.8-1.39,9.06,9.06,0,0,0-.39-4.86s-16.38.43-19.83-19Z",
    fill: "#f7a48b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.08,249.62a.21.21,0,0,0-.26.31c1.57,2.21,6,10.86,10.15,41.71l6.9,56.05s2.15,3.88-1.3,25.87l-4.31,20.7v9.48l12.07,4.31,2.59-92.7,15.55,27.12a8.07,8.07,0,0,1,1,4.73L283,401.59s14.66,3.88,26.3,3.44l6.47-54.32a54.67,54.67,0,0,0-3.88-18.54S300.84,274.68,245.08,249.62Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220,244.64h0a2.09,2.09,0,0,0-2.47,1.75l-11.75,80.17L233,323.11s5.6,4.32,8.19,21.13a212.23,212.23,0,0,1-39.23,8.62s.43,14.23-6,26.31c0,0-12.5,24.57-39.24,73.29l-15.95,28,15.95-128.92s-12.5-.86-7.33-19.83c0,0,15.53-80.63,44-88a63.75,63.75,0,0,1,12.94-1.29c.86,0,13.95,1,13.95,1Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5,276.12c-1.27,8.75-4.24,17.17-7.52,25.35S187.35,317.83,183.9,326c-.88,2.66,5.22,1.88,6.71,1.76,5-.43,10.17-.83,15.21-1.16-5,.74-10.1,1.4-15.12,2-2.22.2-6.28,1.07-7.77-1.16a2.21,2.21,0,0,1,0-2c3.17-8,6.61-16.37,10-24.43s6.65-16.32,8.6-24.9Z",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.66,351.57a42.12,42.12,0,0,0,11.14,2.1,131.81,131.81,0,0,0,14.2.3c6.33-.12,13.62-.73,19.94-1.11-1.88.38-3.76.69-5.64,1-9.45,1.39-19.11,2-28.61.8-3.76-.55-7.67-1.24-11-3.1Z",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.12,366.66a61.56,61.56,0,0,1-14.23,11.21,62,62,0,0,1,14.23-11.21Z",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.08,393.82a403.73,403.73,0,0,1-24.14,39.67,404.9,404.9,0,0,1,24.14-39.67Z",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M231.68,326.13a23.82,23.82,0,0,1,5.18,15.52c-1.67-5.25-3.19-10.35-5.18-15.52Z",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M310.16,338.21a13,13,0,0,1,2.14,5.85,14.69,14.69,0,0,1-.42,6.22c-.22-1-.33-2-.48-3.06-.33-2.68-.85-6.34-1.24-9Z",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M264.88,344.24a32.28,32.28,0,0,1,3.88,12.5,32.35,32.35,0,0,1-3.88-12.5Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M287.74,398.57c6.45.89,12.84,2.47,19.4,2.15-5.79,2.14-13.95.4-19.4-2.15Z",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M261.87,282.16a77.53,77.53,0,0,1,3.85,9.93,76.2,76.2,0,0,1,2.61,10.33,76.77,76.77,0,0,1-3.85-9.94,78.35,78.35,0,0,1-2.61-10.32Z",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M247.26,339.08l16.33-25.88,5.66-5.66a1.4,1.4,0,0,1,2.29,1.54l-3.21,7.57L251.72,342a2.65,2.65,0,0,1-3.74.71h0A2.66,2.66,0,0,1,247.26,339.08Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.57,
    cy: 288.72,
    rx: 22.53,
    ry: 8.79,
    transform: "translate(-114.61 362.56) rotate(-56.15)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.57,
    cy: 288.72,
    rx: 22.53,
    ry: 8.79,
    transform: "translate(-114.61 362.56) rotate(-56.15)",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M296.42,271.3c-4-2.7-12.92,3.48-19.85,13.81s-9.28,20.9-5.25,23.61,12.92-3.48,19.85-13.82S300.45,274,296.42,271.3ZM289.77,294c-5.39,8-12.31,12.83-15.47,10.72s-1.34-10.35,4.05-18.38,12.31-12.83,15.47-10.72S295.16,286,289.77,294Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.06,
    cy: 290.15,
    rx: 17.52,
    ry: 6.88,
    transform: "translate(-115.14 364.43) rotate(-56.15)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.19,192.91s4.75,9.48,54.76,16c0,0,31.47,3.88,44.41-2.16A468.5,468.5,0,0,1,197.19,192.91Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M197.19,192.91s4.75,9.48,54.76,16c0,0,31.47,3.88,44.41-2.16A468.5,468.5,0,0,1,197.19,192.91Z",
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 227.83,
    y: 181.85,
    width: 40.51,
    height: 68.12,
    rx: 20.26,
    transform: "translate(84.94 -69.66) rotate(19.23)",
    fill: "#f9b499"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M214.44,197.65s-3.23,22.2,8.84,33.84c0,0-.09-6.57,1.14-9.21l2.18-7.23s6.38-.16,7.67-14.81C234.27,200.24,221.77,199.37,214.44,197.65Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.19,192.91S239.88,205,296.36,206.7a55,55,0,0,0-17.25-5.6l-2.15-22s-1.3-14.23-22.85-11.21c0,0-5.18,1.72-11.21-2.59,0,0-17.25-6-23.29,16.82l-3.88,10.34A151.64,151.64,0,0,0,197.19,192.91Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270.09,214.56l2.09-6.41a17.89,17.89,0,0,0,.56-2.83l4.31.43A20.57,20.57,0,0,1,270.09,214.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.71,
    cy: 216.4,
    rx: 4.31,
    ry: 6.9,
    fill: "#f9b499"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288.94,403.16s-5.95,9.2-7.24,18.26c0,0-3.45,12.93,4.31,15.52,0,0,11.26,3.11,17.57-16.85a21.31,21.31,0,0,0,1-6.34l.07-8.75A155.74,155.74,0,0,1,288.94,403.16Z",
    fill: "#f9b499"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,325l8.53-3.6s15.64-12.84,24.1-4.07a4.92,4.92,0,0,1,1.29,2.43c.85,4,1.26,15.31-21.08,16.73l-7.3,3.11S238.77,330.75,234.8,325Z",
    fill: "#f9b499"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.8fd3635b0981b13c2275f28282e0a5a5.svg";
export { ForwardRef as ReactComponent };